import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from 'react';
import classNames from 'classnames';
import { throttle } from '../../helpers/';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const BAR_WIDTH = 24;
const RESIZE_LIMIT = 50;
export const isPositionValid = position => {
  const pos = parseInt(position, 10);

  if (pos >= 0 && pos <= 100) {
    return true;
  }

  return false;
};
export default class CosmeticScrollbar extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "update", throttle(() => {
      this.forceUpdate();
    }, RESIZE_LIMIT));

    this.scrollbar = /*#__PURE__*/React.createRef();
    this.barWidth = BAR_WIDTH;
  }

  componentDidMount() {
    window.addEventListener('resize', this.update);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.update);
  }

  calculateBarPosition(percent) {
    const percen = parseInt(percent, 10);
    const scrollAreaWidth = this.scrollbar.current ? this.scrollbar.current.offsetWidth : 0;
    const barsThatFitIntoScrollArea = scrollAreaWidth / this.barWidth;
    const position = barsThatFitIntoScrollArea * percen; // bar starts inside of the scroll area

    return position - percen;
  }

  render() {
    const {
      lightTheme,
      position
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      "aria-hidden": "true",
      ref: this.scrollbar,
      className: classNames(style.CosmeticScrollbar, {
        [style.lightTheme]: lightTheme
      }),
      "data-id": "cosmetic-scrollbar_index_div",
      children: /*#__PURE__*/_jsx("div", {
        className: classNames(style.bar, {
          [style.lightThemeBar]: lightTheme
        }),
        style: {
          width: "".concat(this.barWidth, "px"),
          transform: "translateX(".concat(this.calculateBarPosition(position), "%)")
        },
        "data-id": "cosmetic-scrollbar_index_div_div_1"
      })
    });
  }

}
CosmeticScrollbar.defaultProps = {
  position: 0
};